import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { authFB, storage } from '../../../helpers/Firebase';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
    COM_INFRA_CODE,
    COM_INFRA_DESTINATION,
    COM_INFRA_AREA,
    COM_INFRA_PROJECT,
    COM_INFRA_TYPE,
    COM_INFRA_STATUS,
    COM_INFRA_SUPPLIER,
    COM_INFRA_USER_ASSIGN,
    COM_INFRA_LIST,
    COM_INFRA_EDIT,
    COM_INFRA_ANSWER,
    COM_INFRA_UPLOAD_SET
} from "../../actions";

import {
    ComInfraCodeSuccess, ComInfraCodeError,
    ComInfraDestinationSuccess, ComInfraDestinationError,
    ComInfraAreaSuccess, ComInfraAreaError,
    ComInfraProjectSuccess, ComInfraProjectError,
    ComInfraTypeSuccess, ComInfraTypeError,
    ComInfraStatusSuccess, ComInfraStatusError,
    ComInfraSupplierSuccess, ComInfraSupplierError,
    ComInfraUserAssignSuccess, ComInfraUserAssignError,
    ComInfraListSuccess, ComInfraListError,
    ComInfraEditSuccess, ComInfraEditError,
    ComInfraAnswerSuccess, ComInfraAnswerError,
    ComInfraUploadSetSuccess, ComInfraUploadSetError
} from '../../actions';

export function* watchComInfraCode() { yield takeEvery(COM_INFRA_CODE, onComInfraCode); }
export function* watchComInfraDestination() { yield takeEvery(COM_INFRA_DESTINATION, onComInfraDestination); }
export function* watchComInfraArea() { yield takeEvery(COM_INFRA_AREA, onComInfraArea); }
export function* watchComInfraProject() { yield takeEvery(COM_INFRA_PROJECT, onComInfraProject); }
export function* watchComInfraType() { yield takeEvery(COM_INFRA_TYPE, onComInfraType); }
export function* watchComInfraStatus() { yield takeEvery(COM_INFRA_STATUS, onComInfraStatus); }
export function* watchComInfraSupplier() { yield takeEvery(COM_INFRA_SUPPLIER, onComInfraSupplier); }
export function* watchComInfraUserAssign() { yield takeEvery(COM_INFRA_USER_ASSIGN, onComInfraUserAssign); }
export function* watchComInfraList() { yield takeEvery(COM_INFRA_LIST, onComInfraList); }
export function* watchComInfraEdit() { yield takeEvery(COM_INFRA_EDIT, onComInfraEdit); }
export function* watchComInfraAnswer() { yield takeEvery(COM_INFRA_ANSWER, onComInfraAnswer); }
export function* watchComInfraUploadSet() { yield takeEvery(COM_INFRA_UPLOAD_SET, onComInfraUploadSet); }

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const postAsync = async (endpoint, payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + endpoint, {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onComInfraUploadSetAsync = async (file, uploadId) => {
    var storageRef = storage.ref();
    let filename = `${uploadId}_${file.name}`;
    return await new Promise((success, reject) => {
        var uploadTask = storageRef.child(storagePath + '/communicationinfradocs/' + filename).put(file);
        uploadTask.on('state_changed',
            function (snapshot) {
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
            },
            function (error) {
                reject({ uploadId, name: filename, original: file.name, message: error.code, url: '', type: file.type, size: file.size, path: 'communicationinfradocs/' });
            },
            function () {
                uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                    success({ uploadId, message: 'success', name: filename, original: file.name, name_document: file.name, url: downloadURL });
                });
            });
    });
};

function* onComInfraCode(data) {
    try {
        const response = yield call(postAsync, 'communication/communicationInfra/search/code', data.payload);
        yield put(ComInfraCodeSuccess(response.data));
    } catch (error) {
        yield put(ComInfraCodeError(error));
    }
}

function* onComInfraDestination(data) {
    try {
        const response = yield call(postAsync, 'communication/communicationInfra/search/destination', data.payload);
        yield put(ComInfraDestinationSuccess(response.data));
    } catch (error) {
        yield put(ComInfraDestinationError(error));
    }
}

function* onComInfraArea(data) {
    try {
        const response = yield call(postAsync, 'communication/communicationInfra/search/area', data.payload);
        yield put(ComInfraAreaSuccess(response.data));
    } catch (error) {
        yield put(ComInfraAreaError(error));
    }
}

function* onComInfraProject(data) {
    try {
        const response = yield call(postAsync, 'communication/communicationInfra/search/project', data.payload);
        yield put(ComInfraProjectSuccess(response.data));
    } catch (error) {
        yield put(ComInfraProjectError(error));
    }
}

function* onComInfraType(data) {
    try {
        const response = yield call(postAsync, 'communication/communicationInfra/search/communicationtype', data.payload);
        yield put(ComInfraTypeSuccess(response.data));
    } catch (error) {
        yield put(ComInfraTypeError(error));
    }
}

function* onComInfraStatus(data) {
    try {
        const response = yield call(postAsync, 'communication/communicationInfra/search/status', data.payload);
        yield put(ComInfraStatusSuccess(response.data));
    } catch (error) {
        yield put(ComInfraStatusError(error));
    }
}

function* onComInfraSupplier(data) {
    try {
        const response = yield call(postAsync, 'communication/communicationInfra/search/supplier', data.payload);
        yield put(ComInfraSupplierSuccess(response.data));
    } catch (error) {
        yield put(ComInfraSupplierError(error));
    }
}

function* onComInfraUserAssign(data) {
    try {
        const response = yield call(postAsync, 'communication/communicationInfra/search/userassign', data.payload);
        yield put(ComInfraUserAssignSuccess(response.data));
    } catch (error) {
        yield put(ComInfraUserAssignError(error));
    }
}

function* onComInfraList(data) {
    try {
        const response = yield call(postAsync, 'communication/communicationInfra/list', data.payload);
        yield put(ComInfraListSuccess(response.data));
    } catch (error) {
        yield put(ComInfraListError(error));
    }
}

function* onComInfraEdit(data) {
    let response;
    try {
        response = yield call(postAsync, 'communication/communicationInfra/edit', data.payload);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(ComInfraEditSuccess(response.data));
        const { page, num_page, orderBy, filters } = data.payload;
        const list = yield call(postAsync, 'communication/communicationInfra/list', { page: page, num_page: num_page, orderBy: orderBy, filters: filters });
        yield put(ComInfraListSuccess(list.data));
    } catch (error) {
        yield put(ComInfraEditError(error));
    }
}


function* onComInfraAnswer(data) {
    let response;
    try {
        response = yield call(postAsync, 'communication/communicationInfra/update', data.payload);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(ComInfraAnswerSuccess(response.data));
        const { page, num_page, orderBy, filters } = data.payload;
        const list = yield call(postAsync, 'communication/communicationInfra/list', { page: page, num_page: num_page, orderBy: orderBy, filters: filters });
        yield put(ComInfraListSuccess(list.data));
    } catch (error) {
        yield put(ComInfraAnswerError(error));
    }
}

function* onComInfraUploadSet({ payload }) {
    const { file, uploadId } = payload;
    try {
        const response = yield call(onComInfraUploadSetAsync, file, uploadId);
        if (response.message === 'success') {
            yield put(ComInfraUploadSetSuccess(response));
        } else {
            yield put(ComInfraUploadSetError(response));
        }
    } catch (error) {
        yield put(ComInfraUploadSetError({ uploadId, name: '', original: file.name, message: error, url: '', path: '' }));
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchComInfraCode),
        fork(watchComInfraDestination),
        fork(watchComInfraArea),
        fork(watchComInfraProject),
        fork(watchComInfraType),
        fork(watchComInfraStatus),
        fork(watchComInfraSupplier),
        fork(watchComInfraUserAssign),
        fork(watchComInfraList),
        fork(watchComInfraEdit),
        fork(watchComInfraAnswer),
        fork(watchComInfraUploadSet)
    ]);
}
